import { PagedMultiSelectField, PagedSingleSelectField, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { companyService } from "../shared/api/companyService";

const fetchConfig = laravelSelectFetchConfig(companyService.optionsKey, (search, page) =>
	companyService.options(search, page).then((x) => x.data),
);

interface Props {
	name: string;
	label: string;
	disabled?: boolean;
	required?: boolean;
	readOnly?: boolean;
}
export const CompanySelectField: FC<Props> = (props) => {
	return <PagedSingleSelectField {...props} fetchConfig={fetchConfig} />;
};

export const CompanyMultiSelectField: FC<Props> = (props) => {
	return <PagedMultiSelectField {...props} fetchConfig={fetchConfig} />;
};
